import { render, staticRenderFns } from "./QuestionImgsAbcd.vue?vue&type=template&id=805345ba&"
import script from "./QuestionImgsAbcd.vue?vue&type=script&lang=ts&"
export * from "./QuestionImgsAbcd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports